import { gql } from '@apollo/client';

export const MemberFragment = gql`
  fragment Member on User {
    id
    email
    fullName
    companyScopes {
      id
      companyId
      scope
    }
  }
`;
